"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFetchResponse = void 0;
async function parseFetchResponse(response, options) {
    if (response.status === 401) {
        options?.on401?.();
        throw new Error('Unauthorized');
    }
    if (!response.ok) {
        const contentType = response.headers.get('content-type');
        let errorMessage = `Server error (${response.status})`;
        try {
            if (contentType && contentType.includes('application/json')) {
                const errorData = await response.json().catch(() => ({}));
                errorMessage = errorData.error
                    || errorData.message
                    || errorMessage;
            }
            else {
                const text = await response.text();
                if (response.status === 404) {
                    errorMessage = 'Endpoint not found. Check if the backend is running and the URL is correct.';
                }
                else {
                    errorMessage = text ? `${errorMessage}: ${text.substring(0, 200)}` : errorMessage;
                }
            }
        }
        catch {
            // keep default errorMessage
        }
        throw new Error(errorMessage);
    }
    try {
        return (await response.json());
    }
    catch {
        throw new Error('Failed to parse response');
    }
}
exports.parseFetchResponse = parseFetchResponse;
